export default __webpack_public_path__ + "1688ed772e3e47a12a4cf065c9b2315f.png";